<svelte:options customElement={{
  tag: 'movie-embed',
  shadow: 'none',
  props: {
    src: { reflect: true, type: 'String' },
    title: { reflect: true, type: 'String' },
    type: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * movie：動画（レスポンシブ 16:9）
   * パーツライブラリ準拠の mod-movie 構造
   * @prop {string} src - 動画URL（YouTube embed等）またはvideoファイル
   * @prop {string} title - iframe title属性
   * @prop {string} type - 'iframe' | 'video'
   */
  export let src = '';
  export let title = '';
  export let type = 'iframe';
</script>

<div class="mod-movie">
  {#if type === 'video'}
    <video controls>
      <source {src} />
      <track kind="captions" />
    </video>
  {:else}
    <iframe
      {src}
      {title}
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  {/if}
</div>
